import {createAction, createAsyncAction} from "typesafe-actions";
import {ICheckedFileIds, IFile} from "./types";
import {INewFileInfo} from "../../components/FileSystem/FilesTree";
import {IUser} from "../user/types";
import {IdObjectsWithId} from "../../utils";
import {IFileData} from "./filedata/types";

export const fetchAllFilesAsyncActions = createAsyncAction(
    'FETCH_ALL_FILES_REQUEST',
    'FETCH_ALL_FILES_SUCCESS',
    'FETCH_ALL_FILES_FAILURE'
)<{}, { files: IdObjectsWithId<IFile> }, { error: Error }>();


export const fetchFileRootWithChildrenAsyncActions = createAsyncAction(
    'FETCH_FILE_ROOT_WITH_CHILDREN_REQUEST',
    'FETCH_FILE_ROOT_WITH_CHILDREN_SUCCESS',
    'FETCH_FILE_ROOT_WITH_CHILDREN_FAILURE'
)<{}, { files: IdObjectsWithId<IFile> }, { error: Error }>();

export interface IFetchFileChildrenAsyncRequestPayload {
    file: IFile;
    resolve: (value?: any | PromiseLike<void> | undefined) => void;
}

export const fetchFileChildrenAsyncActions = createAsyncAction(
    'FETCH_FILE_CHILDREN_REQUEST',
    'FETCH_FILE_CHILDREN_SUCCESS',
    'FETCH_FILE_CHILDREN_FAILURE'
)<IFetchFileChildrenAsyncRequestPayload, { files: IdObjectsWithId<IFile> }, { error: Error }>();


export interface IAddFileAsyncRequestPayload {
    newFileInfo: INewFileInfo,
    user?: IUser;
    parent?: IFile;
    isRoot?: boolean;
}

export const addFileAsyncActions = createAsyncAction(
    'ADD_FILE_REQUEST',
    'ADD_FILE_SUCCESS',
    'ADD_FILE_FAILURE'
)<IAddFileAsyncRequestPayload, { file: IFile }, { error: Error }>();


export interface IRenameFileAsyncRequestPayload {
    file: IFile;
    name: string;
    user?: IUser;
}

export const renameFileAsyncActions = createAsyncAction(
    'RENAME_FILE_REQUEST',
    'RENAME_FILE_SUCCESS',
    'RENAME_FILE_FAILURE'
)<IRenameFileAsyncRequestPayload, { files: IdObjectsWithId<IFile> }, { error: Error }>();

export interface IMoveFileAsyncRequestPayload {
    file: IFile;
    parentPath: string;
    user?: IUser;
}

export const moveFileAsyncActions = createAsyncAction(
    'MOVE_FILE_REQUEST',
    'MOVE_FILE_SUCCESS',
    'MOVE_FILE_FAILURE'
)<IMoveFileAsyncRequestPayload, { files: IdObjectsWithId<IFile> }, { error: Error }>();


export interface IDeleteFileAsyncRequestPayload {
    file: IFile;
    user?: IUser;
}

export const deleteFileAsyncActions = createAsyncAction(
    'DELETE_FILE_REQUEST',
    'DELETE_FILE_SUCCESS',
    'DELETE_FILE_FAILURE'
)<IDeleteFileAsyncRequestPayload, { file: IFile }, { error: Error }>();

export interface ISelectFileActionPayload {
    file: IFile
}

export const selectFileAsyncAction = createAsyncAction(
    'SELECT_FILE_REQUEST',
    'SELECT_FILE_SUCCESS',
    'SELECT_FILE_FAILURE'
)<ISelectFileActionPayload, { id: string, fileData?: IFileData }, { error: Error }>();


export interface ICheckFilesRequestActionPayload {
    folderIds: string[]
    disableUncheck: boolean
}

export interface ICheckFilesSuccessActionPayload {
    checkedFileIds: ICheckedFileIds
}

export const checkFilesAsyncAction = createAsyncAction(
    'CHECK_FILES_REQUEST',
    'CHECK_FILES_SUCCESS',
    'CHECK_FILES_FAILURE'
)<ICheckFilesRequestActionPayload, ICheckFilesSuccessActionPayload, { error: Error }>();

